import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, Button, Box, Text, Image, Flex, useToast } from "@chakra-ui/react";
import { useApiClient } from "../../../../shared/hooks";

interface IEnabledDisabledAccount{
  email:string
  account:string
}

interface Props {
  isOpen: boolean;
  onClose: () => void;
  rowData: any;
}

function ReportedUserModal({ isOpen, onClose, rowData }: Props) {
  const apiClient = useApiClient();
  const toast = useToast();

  const enabledOrDisabledAccountFn = async (data:IEnabledDisabledAccount) => {
    try {
      await apiClient.enableDisableUser(data.email, data.account);
      toast.closeAll();
      toast({
        title: "Success",
        description: `User Account ${data.account}`,
        status: "success",
        isClosable: true,
        duration: 2000,
      });
    } catch (error) {
      console.error("Error:", error);
      toast.closeAll();
      toast({
        title: "Error",
        description:`User Account unable to ${data.account}`,
        status: "error",
        isClosable: true,
        duration: 2000,
      });
    }}
  const actionOnUser = (actionType: string, email: string) => {
    const data: IEnabledDisabledAccount = {
      email,
      account: actionType,
    };

    enabledOrDisabledAccountFn(data);

    onClose();

  };


  return (
    <Modal blockScrollOnMount={true} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        minH="fit-content"
        zIndex="1"
        minWidth={{
          lg: "60vw",
          md: "80vw",
          base: "98vw",
        }}
      >
        <ModalHeader>Reporting Details</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Flex direction="column" align="center" justify="center">
            {/* Reporting User Section */}
            <Flex
              direction="column"
              align="center"
              justify="center"
              mb={4}
            >
              <Text fontWeight="bold" fontSize="lg" mb={2}>
                Reporting User
              </Text>
              <Image
                src={rowData?.reporting_user?.user_profile_image}
                alt="Reporting User"
                boxSize="100px"
                borderRadius="full"
                mb={2}
              />
              <Text fontWeight="bold" fontSize="lg">
                {rowData?.reporting_user?.full_name}
              </Text>
              <Text color="gray.500">{rowData?.reporting_user?.email}</Text>
            </Flex>

            <Box
              borderWidth="1px"
              p={4}
              borderRadius="md"
              boxShadow="md"
              mb={4}
            >
              <Text fontWeight="bold" fontSize="lg" mb={2}>
                Reason for Reports
              </Text>
              <Text>{rowData?.reason || "No reason provided."}</Text>
            </Box>

            {/* Reported User Section */}
            <Flex
              direction="column"
              align="center"
              justify="center"
              mt={4}
            >
              <Text fontWeight="bold" fontSize="lg" mb={2}>
                Reported User
              </Text>
              <Text fontWeight="bold" fontSize="lg">
                {rowData?.reported_user?.full_name}
              </Text>
              <Text color="gray.500">{rowData?.reported_user?.email}</Text>
              <Image
                src={rowData?.reported_user?.user_profile_image}
                alt="Reported User"
                boxSize="100px"
                borderRadius="full"
                mt={2}
              />
            </Flex>
          </Flex>
        </ModalBody>

        <ModalFooter>
        {rowData?.reported_user?.disabled ? (
          <>
          <Button  bg={"green"} mr={3} onClick={()=>actionOnUser('enabled',rowData?.reported_user?.email)} gap={3} >
          Enable User
          </Button>
          </>
            ) : (
              <>
              <Button bg={"red"} mr={3}onClick={()=>actionOnUser('disabled',rowData?.reported_user?.email)} gap={3}>
                Disable User
                </Button>
              </>
            )}
          <Button colorScheme="blue" mr={3} onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ReportedUserModal;
